import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ServiceTechnologyProviders } from 'src/app/model/page/service-technology-providers';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-service-technology-providers',
  templateUrl: './service-technology-providers.component.html',
  styleUrls: ['./service-technology-providers.component.scss']
})
export class ServiceTechnologyProvidersComponent implements OnInit {
  serviceTechnologyProviders: ServiceTechnologyProviders = {} as ServiceTechnologyProviders;

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'service-technology') {
        this.serviceTechnologyProviders.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': 'Service Technology Providers' };
    this.contentfulService.getPageContentResponse(query).then((serviceContentPageEntries) => {
      this.serviceTechnologyProviders.tableSection = [];

      this.mapHtmlTitle(serviceContentPageEntries.items);
      this.mapBanner(serviceContentPageEntries.includes.Entry);
      this.mapPageInfo(serviceContentPageEntries.items);
      this.mapTableSection(serviceContentPageEntries.includes.Entry);
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.serviceTechnologyProviders.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(serviceContentPageEntries: Entry<any>[]) {
    serviceContentPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'];
    this.serviceTechnologyProviders.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    this.serviceTechnologyProviders.banner.lastUpdated = items.pop()?.fields?.['lastUpdated'] as string;
  }

  private mapTableSection(serviceContentPageEntries: Entry<any>[]) {
    serviceContentPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    this.serviceTechnologyProviders.tableSection.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string
    });
  }
}
